// extracted by mini-css-extract-plugin
export default {"project":"Project_project__gx9oP","project__inner":"Project_project__inner__IABq6"};